import type { RoutingStrategy } from '@inlang/paraglide-next';
import type { NextRequest } from 'next/server';

export default function MyDomainStrategy<T extends string>({
  domains,
}: {
  domains: Record<T, Array<`${'http://' | 'https://'}${string}`>>;
}): RoutingStrategy<T> {
  const domainConfig = Object.fromEntries(
    Object.entries(domains).map(([lang, domainArray]) => {
      // Process each domain in the array and create an array of {protocol, hostname} objects
      const domainObjects = (domainArray as Array<string>).map((domain) => {
        const [protocol, rest] = domain.split('://');
        const { hostname } = new URL(domain);
        return { protocol, hostname };
      });

      return [lang, domainObjects];
    })
  ) as Record<T, Array<{ protocol: string; hostname: string }>>;

  return {
    getCanonicalPath(localisedPath) {
      return localisedPath;
    },
    getLocalisedUrl(canonicalPath, targetLocale, isLanguageSwitch) {
      if (!isLanguageSwitch) return { pathname: canonicalPath };

      console.log(
        'amvera region from getlocalisedurl',
        process.env.NEXT_PUBLIC_URL
      );

      const { protocol, hostname } = domainConfig[targetLocale][0];
      return {
        protocol,
        hostname,
        pathname: canonicalPath,
      };
    },
    resolveLocale(request: NextRequest) {
      // First check for NEXT_LOCALE cookie
      const languageCookie = request.cookies.get('NEXT_LOCALE');
      if (
        languageCookie?.value &&
        Object.keys(domainConfig).includes(languageCookie.value)
      ) {
        return languageCookie.value as T;
      }

      // Fall back to domain-based resolution
      console.log('Current hostname:', request.nextUrl.hostname);
      console.log('Request host header:', request.headers.get('host'));
      console.log('Domain config:', domainConfig);

      const requestHost = request.headers.get('host')?.split(':')[0];
      if (!requestHost) return undefined;

      // Check if requestHost matches any hostname in any language's domain array
      for (const [lang, domainObjects] of Object.entries(domainConfig) as [
        string,
        Array<{ protocol: string; hostname: string }>,
      ][]) {
        for (const { hostname } of domainObjects) {
          console.log(`Comparing ${requestHost} === ${hostname}`);
          if (requestHost === hostname) {
            return lang as T;
          }
        }
      }

      return undefined;
    },
  };
}
